import React, {Component} from 'react';
import ExternalLanding from "../ExternalLanding";
import {externalLinks} from "../../requests/external-endpoints";

class HubSpotResourcesSupplier extends Component {
    render() {
        return <ExternalLanding url={externalLinks.resourcesSupplier} />
    }
}

export default HubSpotResourcesSupplier;
